import { isSmDown } from '~/lib/responsive';
import type { ShowFiltersState, useShowFiltersParams } from './';

export const allUnselectedState: ShowFiltersState = {
  filters: {
    tags: { open: false, items: [] },
  },
  panel: { open: false },
};

export const getShowFiltersState = (params: ReturnType<typeof useShowFiltersParams>) => {
  const isShowSmDown = isSmDown();
  return {
    filters: {
      tags: { open: false, items: [] },
    },
    panel: { open: !isShowSmDown && Object.values(params).flat().length > 0 },
  };
};
